













































































import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
import Util from '@/lib/util'
import AbpBase from '@/lib/abpbase'
import PageRequest from '@/store/entities/page-request'
import { getLodop, demoDownloadPDF } from '@/common/js/LodopFuncs'
import Enums from '@/lib/enums'
import storeaddressInfo from '@/store/entities/back-storeaddress-list';
import DateUtils from '@/common/js/DateUtils'
import Preview from 'vue-photo-preview'
import AddShelves from './add-shelves.vue'
import 'vue-photo-preview/dist/skin.css'
import appconst from '@/lib/appconst';
import moment from 'moment'
Vue.use(Preview);

class PageBackShelvesRequest extends PageRequest {
    storeId?: number;
    productSku: string;
    userCode: string;
    productNo: string;
    minStock?: number;
    maxStock?: number;
    productId?: number;
    shelfPosition: string;
    IsRelated?: boolean;
}

@Component({
    name: "pagebackshelves",
    components: { AddShelves }
})
export default class backstockproduct extends AbpBase {
    storeaddressList: Array<storeaddressInfo> = [];
    pagerequest: PageBackShelvesRequest = new PageBackShelvesRequest();
    isWhetherStatus = Enums.getEnum(Enums.WhetherStatus, true);
    creationTime: Date[];
    AddShelvesShow: boolean = false;
    get list() {
        return this.$store.state.backShelves.list;
    };
    get loading() {
        return this.$store.state.backShelves.loading;
    }

    pageChange(page: number) {
        this.$store.commit('backShelves/setCurrentPage', page);
        this.getpage();
    }
    pagesizeChange(pagesize: number) {
        this.$store.commit('backShelves/setPageSize', pagesize);
        this.getpage();
    }
    async searchPage() {
        this.$store.state.backShelves.currentPage = 1;
        this.getpage();
    }

    async add() {
        if (this.pagerequest.storeId > 0) {
            var find = this.storeaddressList.find(c => c.id == this.pagerequest.storeId);
            this.$store.state.backShelves.storeName = find.storeName;
            this.$store.state.backShelves.storeId = find.id;
            this.AddShelvesShow = true;
        } else {
            this.$Message.error("请选择仓库！");
        }

    }
    async getpage() {
        if (this.pagerequest.storeId > 0) {

        }
        else {
            this.$Message.error("请选择仓库！");
            return;
        }
        this.pagerequest.maxResultCount = this.pageSize;
        this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;

        await this.$store.dispatch({
            type: 'backShelves/getAll',
            data: this.pagerequest
        })

    }

    async deleteSelect() {
        var selectionData: any = this.$refs.selection;
        var selection = selectionData.getSelection();
        if (!selection || selection.length == 0) {
            this.$Message.error("选中项不能为空！");
            return;
        }
        this.$Modal.confirm({
            title: "删除货架", content: "确定要批量删除指定货架么，如果存在关联商品删除会失败？", onOk: async () => {
                var ids = [];
                for (var i = 0; i < selection.length; i++) {
                    ids.push(selection[i].id);
                }
                await this.$store.dispatch({
                    type: 'backShelves/Delete',
                    data: { ids: ids }
                });
                this.getpage();
            }
        });
    }

    async clearSelect() {
        var selectionData: any = this.$refs.selection;
        var selection = selectionData.getSelection();
        if (!selection || selection.length == 0) {
            this.$Message.error("选中项不能为空！");
            return;
        }
        this.$Modal.confirm({
            title: "清理货架", content: "确定要批量清理指定货架么，如果存在关联商品并且库存大于0清理会失败？", onOk: async () => {
                var ids = [];
                for (var i = 0; i < selection.length; i++) {
                    ids.push(selection[i].id);
                }
                await this.$store.dispatch({
                    type: 'backShelves/Clear',
                    data: { ids: ids }
                });
                this.getpage();
            }
        });
    }

    async getData() {
        await this.$store.dispatch({
            type: 'backstoreaddress/getAll',
            data: {}
        })
        var a = new storeaddressInfo();
        a.id = null;
        a.storeName = "全部";
        this.storeaddressList = this.$store.state.backstoreaddress.list.filter(function (item) { return item.whetherEffective == true });
        if (this.storeaddressList.length == 1) {
            this.pagerequest.storeId = this.storeaddressList[0].id;
        }
        else {
            this.storeaddressList.push(a);
            this.pagerequest.storeId = null;
        }
    }
  
    get pageSize() {
        return this.$store.state.backShelves.pageSize;
    }
    get totalCount() {
        return this.$store.state.backShelves.totalCount;
    }
    get currentPage() {
        return this.$store.state.backShelves.currentPage;
    }
    columns = [
        {
            type: 'selection',
            width: 60,
            align: 'center',

        },{
            title: '仓库名称',
            key: 'storeName',
            width: 120,
        },
        {
            title: '货架位置',
            key: 'shelfPosition',
            width: 100,

        },
        {
            title: '用户编码',
            key: 'userCode',
            width: 90,
        },
        {
            title: '产品编号',
            key: 'productNo',
            width: 200,
        },
        {
            title: '内码',
            key: 'productId',
            width: 100,
        },
        {
            title: '产品图片',
            key: 'productImgGuid',
            width: 95,
            render: (h: any, params: any) => {
                if (params.row.productImgGuid) {
                    var data = { imageGuid: params.row.productImgGuid, url: null };
                    var url = "";
                    if (params.row.productImgGuid.indexOf("http") != -1) {
                        url = params.row.productImgGuid;
                    }
                    else {
                        this.$store.commit('expressuserinfo/getImgUrl', data);
                        url = data.url;
                    }
                    return h('img', {
                        style: {
                            width: "50px",
                            height: "50px",
                            verticalAlign: "middle"
                        },
                        attrs: {
                            src: url,
                            preview: "yc_" + params.row.id,
                            "preview-text": params.row.orderNumber + "cp"
                        }
                    });

                } else {
                    return h('span', "");
                }
            }
        },
        {
            title: '产品Sku',
            key: 'productSku',
            width: 200,
        },
        {
            title: '库存量',
            key: 'inventory',
            width: 80,
        }, {
            title: '商品名称',
            key: 'productName',
            width: 500,
        },
    ]
    async created() {
        this.getData();
        this.getpage();
    }
}
